import { USER_TYPE } from 'src/components/structure/sidemenu/sidemenu.constants'
import { MENU_POSITIONS } from './context.constants'
import ContextVO from './models/context.vo'

export type TContext = ContextVO

export interface SideMenuResponse {
  id: string
  position: MENU_POSITIONS
  route?: {
    isExternalRoute: boolean
    path: string
  }
  eventLayer: {
    action: string
    label: string
  }
  submenu: {
    id: string
    route: {
      isExternalRoute: boolean
      path: string
    }
    eventLayer: {
      action: string
      label: string
    }
  }[]
}

export interface GuideTourResponse {
  viewedGuideTour: boolean
}

export enum USER_SEGMENTATION {
  SMALL = 'SMALL',
  SEED = 'SEED',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

export interface USER_TYPE_INFO {
  hasCreatedProduct: boolean
  hasRequestedAffiliation: boolean
  hasRequestedCoproduction: boolean
  isAffiliationApproved: boolean
  isCollaborator: boolean
  isCoproductionApproved: boolean
  isNewUser: boolean
  isProductApproved: boolean
  isSalesCoproduction: boolean
  isUserAffiliate: boolean
  isUserCoproducer: boolean
  isUserProducer: boolean
  userSegmentationInfo: USER_SEGMENTATION
  userType: USER_TYPE
}
